import wilayah from "./wilayah.json";

export const WILAYAH = wilayah;
export const PROVINCES = Object.keys(wilayah).sort();
export const CITIES = PROVINCES.flatMap((p) => wilayah[p].map((c) => ({ city: c, province: p }))).sort((a, b) => a.city.localeCompare(b.city));
export const provinceOf = (city) => CITIES.find((c) => c.city === city)?.province || "";

export const JOBS = [
  ["ANY", "Bersedia job apapun"], ["WELD", "Welding / Las"], ["FOOD", "Pengolahan Makanan"], ["KAIGO", "Caregiver / Kaigo"], ["CONST", "Konstruksi"],
  ["AGRI", "Pertanian"], ["MANUF", "Manufaktur"], ["HOTEL", "Perhotelan"], ["AUTO", "Otomotif"], ["ELEC", "Elektronik"], ["FISH", "Perikanan"],
  ["DRIVER", "Sopir"], ["LOGI", "Pergudangan / Logistik"], ["SEW", "Jahit"],
];
export const jobLabel = (code) => JOBS.find(([c]) => c === code)?.[1] || code;

export const PREFECTURES = ["Hokkaido", "Aomori", "Iwate", "Miyagi", "Akita", "Yamagata", "Fukushima", "Ibaraki", "Tochigi", "Gunma", "Saitama", "Chiba", "Tokyo", "Kanagawa",
  "Niigata", "Toyama", "Ishikawa", "Fukui", "Yamanashi", "Nagano", "Gifu", "Shizuoka", "Aichi", "Mie", "Shiga", "Kyoto", "Osaka", "Hyogo", "Nara", "Wakayama",
  "Tottori", "Shimane", "Okayama", "Hiroshima", "Yamaguchi", "Tokushima", "Kagawa", "Ehime", "Kochi", "Fukuoka", "Saga", "Nagasaki", "Kumamoto", "Oita", "Miyazaki", "Kagoshima", "Okinawa"];
